
import React, { PropTypes } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

const ModalAlert = ({ title, bodyText, disableButton, name, ...props }) =>
  <Modal {...props}>
    <Modal.Header className="bg-warning" closeButton={!props.removeCloseButton}>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {bodyText}
      <br /><br />
      {!disableButton ? (
        <Button className="btn btn-warning pull-right" onClick={() => props.onHide(name)}>Zamknij</Button>
      ) : null}
      <br /><br />
    </Modal.Body>
  </Modal>;

export default ModalAlert;


// WEBPACK FOOTER //
// src/routes/eservices/ModalAlert.js